import { Routes, Route } from 'react-router-dom';
import ContratoEnderecoFiscal from './pages/contratos/ContratoEnderecoFiscal';
import Home from './pages/home/Index';
import AboutUs from './pages/aboutUs/Index';
import Planos from './pages/plans/Index';
import Solutions from './pages/solutions/Index';
import Niches from './pages/niches/Index';
import Login from './pages/login/Index';
import Register from './pages/register/Index';
// import Cart from './pages/cart/Index';
import Checkout from './pages/checkout/Index';
import Perfil from './pages/perfil/Index';
import Dashboard from './pages/dashboard/Index';
import FaturasPendentes from './pages/dashboard/components/FaturasPendentes';
import PerfilDashboard from './pages/dashboard/components/PerfilDashboard';
import FaturasPagas from './pages/dashboard/components/FaturasPagas';
import Assinatura from './pages/dashboard/components/Assinatura';
import AssinarContrato from './pages/assinarContrato/Index';
import DetalhesCobranca from './pages/dashboard/components/DetalhesCobranca';
import ResetarSenha from './pages/resetarSenha/Index';
import MudarPlano from './pages/dashboard/components/MudarPlano';
import CancelarAssinatura from './pages/dashboard/components/CancelarAssinatura';
import Certificado from './pages/dashboard/components/Certificado';
import Servicos from './pages/dashboard/components/Servicos';
import NotasFiscaisEmitidas from './pages/dashboard/components/NotasFiscaisEmitidas';
import EmitirNotaServico from './pages/dashboard/components/EmitirNotaServico';
import PoliticaPrivacidade from './pages/politicaDePrivacidade/Index';
import TermosUso from './pages/termosDeUso/Index';
import MetodoPagamento from './pages/dashboard/components/MetodoPagamento';
import ApresentacaoContblack from './pages/apresentacaoContblack/ApresentacaoContblack';
import ApresentacaoEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/ApresentacaoEnderecoFiscal';
import AssinarContratoEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/AssinarContratoEnderecoFiscal';
import CheckoutEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/CheckoutEnderecoFiscal';
import ResidenciaFiscal from './pages/dashboard/components/enderecoFiscal/ResidenciaFiscal';
import FichaCadastral from './pages/dashboard/components/FichaCadastral';
import Documentos from './pages/dashboard/components/Documentos';
import ContratoPlano from './pages/contratos/ContratoPlano';
// import OpenBanking from './pages/dashboard/components/OpenBanking';

import { UserProvider } from './contexts/UserContext';
// import { DiscountProvider } from './contexts/DiscountContext'; 
import { LoginProvider } from './contexts/LoginContext';

import MetaTimeTracking from './hook/MetaTimeTracking';
import RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce from './pages/blog/articles/RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce';
import NuncaDeclareiImposto from './pages/blog/articles/NuncaDeclareiImposto';
import BeneficiosDeDeclararCorretamenteOsImpostos from './pages/blog/articles/BeneficiosDeDeclararCorretamenteOsImpostos';
import FreelancerPj from './pages/blog/articles/FreelancerPj';
import QuantoOCriadorDeConteudoRealmentePagaDeImposto from './pages/blog/articles/QuantoOCriadorDeConteudoRealmentePagaDeImposto';
import Blog from './pages/blog/Index';
import ModalTimer from './hook/ModalTimer';
import Altmodel from './pages/niches/pages/AltModel';
import Freela from './pages/niches/pages/Freela';
import Creator from './pages/niches/pages/Creator';
import Infoprodutor from './pages/niches/pages/Infoprodutor';
import Mei from './pages/niches/pages/Mei';
import AnywhereOffice from './pages/niches/pages/AnywhereOffice';
import DigitalInfluencer from './pages/niches/pages/DigitalInfluencer';
import GamerStreamer from './pages/niches/pages/GamerStreamer';
import DesignerMarkeing from './pages/niches/pages/DesignerMarketing';
import Dev from './pages/niches/pages/Dev';
import Economize from './pages/economize/Economize';
import RegularizacaoFiscal from './pages/regularize/RegularizacaoFiscal';
import DocumentosContabeis from './pages/dashboard/components/DocumentosContabeis';
import CookieNotice from './components/CookieNotice';
// import ServerStatus from './pages/components/ServerStatus';
import NativeShell from './native/NativeShell';

import AnaliseContabil from './pages/dashboard/components/AnaliseContabil';


import FreelaForm from './pages/marketingPages/FreelaForm';
import InfoprodutorForm from './pages/marketingPages/InfoprodutorForm';
import DigitalInfluencerForm from './pages/marketingPages/DigitalInfluencerForm';
import NewFichaCadastral from './pages/dashboard/components/NewFichaCadastral';

function App() {
	return (
		<UserProvider>
				<LoginProvider>
					<NativeShell />
					<MetaTimeTracking />
					<ModalTimer />
					<CookieNotice />
					{/* <ServerStatus /> */}
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/sobreNos" element={<AboutUs />} />
						<Route path="/planos" element={<Planos />} />
						<Route path="/solucoes" element={<Solutions />} />
						<Route path="/nichos" element={<Niches />} />
						<Route path="/nichos/alt-models" element={<Altmodel />} />
						<Route path="/nichos/freela" element={<Freela />} />
						<Route path="/nichos/creator" element={<Creator />} />
						<Route path="/nichos/infoprodutor" element={<Infoprodutor />} />
						<Route path="/nichos/anywhere-office" element={<AnywhereOffice />} />
						<Route path="/nichos/mei" element={<Mei />} />
						<Route path="/nichos/digital-influencer" element={<DigitalInfluencer />} />
						<Route path="/nichos/gamer-streamer" element={<GamerStreamer />} />
						<Route path="/nichos/designer-marketing" element={<DesignerMarkeing />} />
						<Route path="/nichos/dev" element={<Dev />} />
						<Route path="/Login" element={<Login />} />
						<Route path="/cadastro" element={<Register />} />
						{/* <Route path="/carrinho" element={<Cart />} /> */}
						<Route path="/checkout" element={<Checkout />} />
						<Route path="/perfil" element={<Perfil />} />
						<Route path="/assinarContrato" element={<AssinarContrato />} />
						<Route path="/regularize" element={<RegularizacaoFiscal />} />
						<Route path="/economize" element={<Economize />} />
						<Route path="/dashboard" element={<Dashboard />} />
						<Route path="/dashboard/documentos-contabeis" element={<DocumentosContabeis />} />
						<Route path="/dashboard/servicos" element={<Servicos />} />
						<Route path="/dashboard/faturas/pendentes" element={<FaturasPendentes />} />
						<Route path="/dashboard/faturas/pagas" element={<FaturasPagas />} />
						<Route path="/dashboard/notasFiscaisEmitidas" element={<NotasFiscaisEmitidas />} />
						<Route path="/dashboard/emitirNotaServico" element={<EmitirNotaServico />} />
						<Route path="/dashboard/perfil" element={<PerfilDashboard />} />
						<Route path="/dashboard/assinatura" element={<Assinatura />} />
						<Route path="/dashboard/detalhesCobranca" element={<DetalhesCobranca />} />
						<Route path="/dashboard/alterarMetodoPagamento" element={<MetodoPagamento />} />
						<Route path="/dashboard/mudarPlano" element={<MudarPlano />} />
						<Route path="/resetarSenha" element={<ResetarSenha />} />
						<Route path="/cancelarAssinatura" element={<CancelarAssinatura />} />
						<Route path="/dashboard/certificado" element={<Certificado />} />
						<Route path="/dashboard/fichaCadastral" element={<NewFichaCadastral />} />
						<Route path="/dashboard/documentos" element={<Documentos />} />
						<Route path="/dashboard/apresentacaoEnderecoFiscal" element={<ApresentacaoEnderecoFiscal />} />
						<Route path="/dashboard/assinarContratoEnderecoFiscal" element={<AssinarContratoEnderecoFiscal />} />
						<Route path="/dashboard/checkoutEnderecoFiscal" element={<CheckoutEnderecoFiscal />} />
						<Route path="/dashboard/residenciaFiscal" element={<ResidenciaFiscal />} />
						<Route path="/dashboard/analise-contabil" element={<AnaliseContabil />} />
						{/* <Route path="/dashboard/openBanking" element={<OpenBanking />} /> */}
						<Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
						<Route path="/contrato-plano" element={<ContratoPlano />} />
						<Route path="/contrato-endereco-fiscal" element={<ContratoEnderecoFiscal />} />
						<Route path="/termos-de-uso" element={<TermosUso />} />
						<Route path="/apresentacao-contblack" element={<ApresentacaoContblack />} />
						<Route path="/blog" element={<Blog />} />
						<Route path="/blog/riscos-de-nao-declarar-os-impostos-devidos-o-que-pode-acontecer-com-voce" element={<RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce />} />
						<Route path="/blog/nunca-declarei-imposto" element={<NuncaDeclareiImposto />} />
						<Route path="/blog/beneficios-de-declarar-corretamente-os-impostos" element={<BeneficiosDeDeclararCorretamenteOsImpostos />} />
						<Route path="/blog/freelancer-pj" element={<FreelancerPj />} />
						<Route path="/blog/quanto-o-criador-de-conteudo-realmente-paga-de-imposto-e-como-pagar-menos-de-forma-legal" element={<QuantoOCriadorDeConteudoRealmentePagaDeImposto />} />

						{/* Marketing Pages */}
						<Route path="/nichos/freela-form" element={<FreelaForm />} />
						<Route path="/nichos/infoprodutor-form" element={<InfoprodutorForm />} />
						<Route path="/nichos/digital-influencer-form" element={<DigitalInfluencerForm />} />
					</Routes>
				</LoginProvider>
		</UserProvider>
	);
}

export default App;
